import { render, staticRenderFns } from "./HubParagraphs.vue?vue&type=template&id=c049996e&"
import script from "./HubParagraphs.vue?vue&type=script&lang=js&"
export * from "./HubParagraphs.vue?vue&type=script&lang=js&"
import style0 from "./HubParagraphs.vue?vue&type=style&index=0&id=c049996e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports